import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'padPipe',
    standalone: false
})

export class PadPipe implements PipeTransform {

    transform(num: number): string {
        if (num){
            return num.toString().padStart(5, '0');
        }
        return '';
    }

}